import axios from 'axios'

export default class TipoIntervencao {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoIntervencao`
    this.tokenBearer = tokenBearer
  }

  getTipoIntervencao () {
    return new Promise(async (resolve, reject) => {
      let optionsTipoIntervencao = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseTipoIntervencao = await axios(optionsTipoIntervencao)
        resolve(responseTipoIntervencao)
      } catch (err) {
        reject(err)
      }
    })
  }
}
